import {Settings} from '@ui/settings/settings';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {slugifyString} from '@ui/utils/string/slugify-string';
import originalTemplates from '../../../supabase/functions/_shared/seo/seo-tags.json';
import {renderBlade} from '../../../supabase/functions/_shared/seo/blade';

/**
 * Page titles and meta tags. Laravel rendered the "seo-tags" blade views on
 * the server and sent them with page data, here the same templates (custom
 * ones from admin > settings > seo, or the originals) are rendered in the
 * browser. Crawlers get prerendered pages from the "seo" edge function.
 */

export type SeoView = keyof typeof originalTemplates;

let customTemplates: Partial<Record<SeoView, string>> = {};

export function setCustomSeoTemplates(templates: Partial<Record<SeoView, string>> | null) {
  customTemplates = templates ?? {};
}

function dotGet(source: any, path: string) {
  return path.split('.').reduce((value, key) => (value == null ? undefined : value[key]), source);
}

export function renderSeoTags(
  view: SeoView,
  vars: Record<string, unknown> = {},
  settings: Settings = getBootstrapData()?.settings,
): string {
  const i18n = getBootstrapData()?.i18n;
  const lines = i18n?.locales?.find(l => l.language === i18n.active)?.lines;
  try {
    return renderBlade(customTemplates[view] ?? originalTemplates[view], {
      vars,
      baseUrl: settings?.base_url ?? window.location.origin,
      setting: name => dotGet(settings, name) ?? (settings as any)?.[name],
      translate: text => (lines as Record<string, string> | undefined)?.[text] ?? text,
      slugify: text => slugifyString(text),
    });
  } catch {
    return '';
  }
}
